(function () {
  if (window.FitnessBentoBundleAddonsLoaded) {
    return;
  }

  window.FitnessBentoBundleAddonsLoaded = true;


  /* =========================
     CART
     ========================= */

  async function getCart() {
    const response = await fetch(
      window.Shopify.routes.root +
        'cart.js?_=' +
        Date.now(),
      {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to read cart.'
      );
    }

    return response.json();
  }


  /* =========================
     BUNDLE SUBSCRIPTION
     ========================= */

  function findBundleSubscription(
    root,
    cart
  ) {
    if (!root || !cart) {
      return null;
    }

    const bundleProductId =
      root.dataset.bundleProductId;

    if (!bundleProductId) {
      return null;
    }

    const bundleItem =
      cart.items.find(function (item) {
        return (
          String(item.product_id) ===
            String(bundleProductId) &&
          item.selling_plan_allocation
        );
      });

    if (
      !bundleItem ||
      !bundleItem.selling_plan_allocation ||
      !bundleItem
        .selling_plan_allocation
        .selling_plan
    ) {
      return null;
    }

    return {
      productId:
        bundleItem.product_id,

      sellingPlanId:
        bundleItem
          .selling_plan_allocation
          .selling_plan
          .id,

      sellingPlanName:
        bundleItem
          .selling_plan_allocation
          .selling_plan
          .name || ''
    };
  }


  /* =========================
     COMPONENT STATE
     ========================= */

  function setComponentState(
    root,
    bundleSubscription
  ) {
    if (!root) return;

    const notice =
      root.querySelector(
        '[data-fb-bundle-addons-notice]'
      );

    const buttons =
      root.querySelectorAll(
        '[data-fb-bundle-addon-add]'
      );

    if (bundleSubscription) {
      root.dataset.bundleReady = 'true';

      root.dataset.sellingPlanId =
        bundleSubscription.sellingPlanId;

      buttons.forEach(function (button) {
        button.disabled = false;
      });

      if (notice) {
        notice.textContent =
          'Your Meal Bundle is in cart. Choose any extras you’d like added to every weekly order.';
      }

      return;
    }

    root.dataset.bundleReady = 'false';

    delete root.dataset.sellingPlanId;

    buttons.forEach(function (button) {
      button.disabled = true;
    });

    if (notice) {
      notice.textContent =
        'Add your Meal Bundle to cart first, then choose any weekly extras.';
    }
  }


  async function refreshComponentState(
    root
  ) {
    if (!root) return;

    try {
      const cart =
        await getCart();

      const bundleSubscription =
        findBundleSubscription(
          root,
          cart
        );

      setComponentState(
        root,
        bundleSubscription
      );

    } catch (error) {
      console.warn(
        'Fitness Bento bundle add-on state error:',
        error
      );
    }
  }


  function refreshAllComponents() {
    document
      .querySelectorAll(
        '[data-fb-bundle-addons]'
      )
      .forEach(function (root) {
        refreshComponentState(root);
      });
  }


  /* =========================
     QUANTITY
     ========================= */

  function getProduct(element) {
    return element.closest(
      '[data-fb-bundle-addon-product]'
    );
  }


  function getQuantityInput(element) {
    const product =
      getProduct(element);

    if (!product) {
      return null;
    }

    return product.querySelector(
      '[data-fb-bundle-addon-qty]'
    );
  }


  function normaliseQuantity(input) {
    if (!input) {
      return 1;
    }

    let quantity =
      parseInt(input.value, 10);

    if (
      !Number.isFinite(quantity) ||
      quantity < 1
    ) {
      quantity = 1;
    }

    input.value = quantity;

    return quantity;
  }

  /* =========================
   REFRESH CART DRAWER
   ========================= */

async function refreshCartDrawer() {
  const response = await fetch(
    window.Shopify.routes.root +
      'cart?section_id=cart-drawer&_=' +
      Date.now(),
    {
      headers: {
        Accept: 'text/html'
      },
      cache: 'no-store'
    }
  );

  if (!response.ok) {
    throw new Error(
      'Unable to refresh cart drawer.'
    );
  }

  const text =
    await response.text();

  const html =
    new DOMParser().parseFromString(
      text,
      'text/html'
    );


  /* Cart drawer items */

  const currentItems =
    document.querySelector(
      'cart-drawer-items'
    );

  const freshItems =
    html.querySelector(
      'cart-drawer-items'
    );

  if (
    currentItems &&
    freshItems
  ) {
    currentItems.replaceWith(
      freshItems
    );
  }


  /* Cart drawer total */

  const currentTotals =
    document.getElementById(
      'FitnessBento-CartDrawer-Totals'
    );

  const freshTotals =
    html.getElementById(
      'FitnessBento-CartDrawer-Totals'
    );

  if (
    currentTotals &&
    freshTotals
  ) {
    currentTotals.innerHTML =
      freshTotals.innerHTML;
  }


  /* Make sure drawer isn't marked empty */

  const cartDrawer =
    document.querySelector(
      'cart-drawer'
    );

  if (cartDrawer) {
    cartDrawer.classList.remove(
      'is-empty'
    );
  }
}


  /* =========================
     ADD ADD-ON
     ========================= */

  async function addBundleAddon(
    button
  ) {
    if (
      !button ||
      button.disabled
    ) {
      return;
    }

    const root =
      button.closest(
        '[data-fb-bundle-addons]'
      );

    const product =
      getProduct(button);

    if (
      !root ||
      !product
    ) {
      return;
    }

    /*
      Re-check Shopify's actual cart
      immediately before adding.

      This prevents us from using stale
      subscription information.
    */
    let cart;
    let bundleSubscription;

    try {
      cart =
        await getCart();

      bundleSubscription =
        findBundleSubscription(
          root,
          cart
        );

    } catch (error) {
      console.error(
        'Fitness Bento bundle cart error:',
        error
      );

      return;
    }

    if (!bundleSubscription) {
      setComponentState(
        root,
        null
      );

      return;
    }

    const variantId =
      product.dataset.variantId;

    const quantityInput =
      product.querySelector(
        '[data-fb-bundle-addon-qty]'
      );

    const quantity =
      normaliseQuantity(
        quantityInput
      );

    const status =
      product.querySelector(
        '[data-fb-bundle-addon-status]'
      );

    if (!variantId) {
      if (status) {
        status.textContent =
          'Unable to add this product.';
      }

      return;
    }

    const originalText =
      button.textContent.trim();

    button.disabled = true;
    button.textContent =
      'Adding...';

    if (status) {
      status.textContent = '';
    }

    try {
      const response = await fetch(
        window.Shopify.routes.root +
          'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id:
                  Number(variantId),

                quantity:
                  quantity,

                selling_plan:
                  Number(
                    bundleSubscription
                      .sellingPlanId
                  )
              }
            ]
          })
        }
      );

      const data =
        await response.json();

      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Unable to add this product.'
        );
      }

      button.textContent =
        'Added ✓';

      if (status) {
        status.textContent =
          quantity === 1
            ? 'Added to your weekly order.'
            : quantity +
              ' added to your weekly order.';
      }
      try {
  await refreshCartDrawer();
} catch (refreshError) {
  console.warn(
    'Fitness Bento bundle drawer refresh failed:',
    refreshError
  );
}

      /*
        Keep button inactive briefly so
        duplicate clicks cannot occur.
      */
      setTimeout(function () {
        button.disabled = false;
        button.textContent =
          originalText;
      }, 1400);

    } catch (error) {
      console.error(
        'Fitness Bento bundle add-on error:',
        error
      );

      button.disabled = false;
      button.textContent =
        originalText;

      if (status) {
        status.textContent =
          error.message ||
          'Something went wrong. Please try again.';
      }
    }
  }


  /* =========================
     MAIN BUNDLE ADD EVENT
     ========================= */

  /*
    When the customer clicks the normal
    Meal Bundle Add to Cart button, Appstle /
    Dawn performs that add separately.

    We then re-check the cart several times
    while that request completes.
  */

  function scheduleBundleChecks() {
    [
      400,
      800,
      1400,
      2200
    ].forEach(function (delay) {
      setTimeout(
        refreshAllComponents,
        delay
      );
    });
  }


  /* =========================
     CLICK EVENTS
     ========================= */

  document.addEventListener(
    'click',
    function (event) {

      /* Quantity minus */

      const minusButton =
        event.target.closest(
          '[data-fb-bundle-addon-minus]'
        );

      if (minusButton) {
        event.preventDefault();

        const input =
          getQuantityInput(
            minusButton
          );

        if (!input) return;

        const current =
          normaliseQuantity(
            input
          );

        input.value =
          Math.max(
            1,
            current - 1
          );

        return;
      }


      /* Quantity plus */

      const plusButton =
        event.target.closest(
          '[data-fb-bundle-addon-plus]'
        );

      if (plusButton) {
        event.preventDefault();

        const input =
          getQuantityInput(
            plusButton
          );

        if (!input) return;

        const current =
          normaliseQuantity(
            input
          );

        input.value =
          current + 1;

        return;
      }


      /* Add recurring add-on */

      const addButton =
        event.target.closest(
          '[data-fb-bundle-addon-add]'
        );

      if (addButton) {
        event.preventDefault();

        addBundleAddon(
          addButton
        );

        return;
      }


      /*
        Standard Dawn product submit button.

        Only schedule checks when the click
        occurred inside our Meal Bundle
        product section.
      */

      const productSubmit =
        event.target.closest(
          '.product-form__submit'
        );

      if (
        productSubmit &&
        productSubmit.closest(
          '.fb-subscription-boxes-product'
        )
      ) {
        scheduleBundleChecks();
      }
    }
  );


  /* =========================
     INPUT
     ========================= */

  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.matches(
          '[data-fb-bundle-addon-qty]'
        )
      ) {
        normaliseQuantity(
          event.target
        );
      }
    }
  );


  /* =========================
     INITIALISE
     ========================= */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      refreshAllComponents
    );
  } else {
    refreshAllComponents();
  }

})();